module.exports = __webpack_public_path__ + "static/image3-a008079967291f04a7ac8ae22bb079d5.jpg";